import { CapoPlugin } from "/app/cms_public/node_modules/.pnpm/@unhead+vue@1.11.20_vue@3.5.12_typescript@5.7.3_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];